import * as dataTypes from "../../data/orders/types";

export const { orderT } = dataTypes;
export type Order = dataTypes.Order;
